// extracted by mini-css-extract-plugin
export default {"saudiSymbol":"currencySymbol_saudiSymbol__bm3Nd"};